import { push } from "connected-react-router";
import { isEmpty } from "ramda";
import { useCallback, useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { SortingRule } from "react-table";
import { createStructuredSelector } from "reselect";
import FilterTable from "../../../components/FilterTable/FilterTable";
import ConfirmModal from "../../../components/Modals/ConfirmModal/ConfirmModal";
import AddEditNotifyModal from "../../../components/Modals/ConsoleAdminModal/NotifyManagementModal/AddEditNotifyModal";
import ResponseModal from "../../../components/Modals/ResponseModal/ResponseModal";
import Table from "../../../components/Table/Table";
import { ROUTES } from "../../../module/constants";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";
import Panel from "../../../ui/Panel/Panel";
import { formatDateFromMillisecondsStringToDDMMYYYY } from "../../../utils/utils";
import {
  deleteNotifyAction,
  getAllRolesAction,
  getNotificationsAction,
  replayNotifyAction,
  sendNotifyAction,
  updateNotifyAction,
} from "./module/actions";
import {
  INotify,
  INotifyAdminProps,
  INotifyCall,
  INotifyDate,
  INotifyGet,
  NOTIFY_FORM_FILTER,
  TypeFilter,
} from "./module/constants";
import messages from "./module/messages";
import {
  allRolesSelector,
  notifySelector,
  responseAddEditSelector,
  responseDeleteSelector,
  responseReplaySelector,
} from "./module/selectors";
import classes from "./NotifyManagement.module.scss";
import filterMessages from "../../../translations/filterMessages";

const form = NOTIFY_FORM_FILTER;
const ONE_MSEC_TO_MIDNIGHT = 86399999;

const NotifyManagement = (props: INotifyAdminProps) => {
  const {
    changeLocation,
    notifications,
    responseDelete,
    responseAddEditState,
    responseReplay,
    allRoles,
    getNotifications,
    getAllRoles,
    deleteNotify,
    sendNotify,
    updateNotify,
    replayNotify,
    loader,
  } = props;

  const [filter, setFilter] = useState([] as any[]);
  const [niceData, setNiceData] = useState([] as any[]);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showResponseDeleteModal, setShowResponseDeleteModal] = useState(false);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [showResponseReplayModal, setShowResponseReplayModal] = useState(false);

  const [toEdit, setToEdit] = useState({} as INotifyDate);
  const [isEdit, setIsEdit] = useState(false);
  const [toDel, setToDel] = useState("");
  const [isDel, setIsDel] = useState(false);
  const [toReplay, setToReplay] = useState({} as INotifyGet);
  const [isReplay, setIsReplay] = useState(false);

  const [pageTotalNumber, setPageTotalNumber] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [sortBy, setSortBy] = useState<SortingRule<{}>[]>([]);

  useEffect(() => {
    getAllRoles();
  }, []);

  useEffect(() => {
    if (!notifications || notifications.messages.length === 0)
      getNotificationsPaginationTableData(0, 10, filter);
  }, [filter]);

  useEffect(() => {
    if (notifications && notifications.pageTotalNumber) {
      setPageTotalNumber(notifications.pageTotalNumber);
      setTotalElements(notifications.totalElements);
    }
    if (notifications && notifications.messages) {
      let list: any[] = [];
      notifications.messages.forEach((el) =>
        list.push({
          uniqueId: el.uniqueId,
          title: el.title,
          message: el.message,
          startDate: formatDateFromMillisecondsStringToDDMMYYYY(
            el.startDate.toString()
          ),
          roleList: el.roleList,
        })
      );
      setNiceData(list);
    }
  }, [notifications]);

  const getNotificationsPaginationTableData = useCallback(
    (
      pageNumber: number,
      pageSize: number,
      filter: any[],
      sortBy: SortingRule<{}>[] = []
    ) => {
      setPageIndex(pageNumber);
      setPageSize(pageSize);
      setSortBy(sortBy);
      let callBody: INotifyCall = {
        pageNumber: pageNumber + 1,
        pageSize: pageSize,
        title: filter?.filter(
          (filterElement: any) => filterElement.id === TypeFilter.titleFilter
        )[0]?.value
          ? filter?.filter(
              (filterElement: any) =>
                filterElement.id === TypeFilter.titleFilter
            )[0]?.value
          : "",
        message: filter?.filter(
          (filterElement: any) => filterElement.id === TypeFilter.textFilter
        )[0]?.value
          ? filter?.filter(
              (filterElement: any) => filterElement.id === TypeFilter.textFilter
            )[0]?.value
          : "",
        date1: filter?.filter(
          (filterElement: any) =>
            filterElement.id === TypeFilter.startDateFilter
        )[0]?.value[0]
          ? filter?.filter(
              (filterElement: any) =>
                filterElement.id === TypeFilter.startDateFilter
            )[0]?.value[0]
          : "",
        date2: filter?.filter(
          (filterElement: any) =>
            filterElement.id === TypeFilter.startDateFilter
        )[0]?.value[1]
          ? new Date(
              new Date(
                filter?.filter(
                  (filterElement: any) =>
                    filterElement.id === TypeFilter.startDateFilter
                )[0]?.value[1]
              ).getTime() + ONE_MSEC_TO_MIDNIGHT
            )
          : "",
      };

      getNotifications(callBody, sortBy);
    },
    []
  );

  const onSubmit: any = (values: any) => {
    const { advancedSearchFilter, ...rest } = values;
    let valueFilter: any[] = [];
    if (values && isEmpty(values)) return setFilter([]);
    if (!isEmpty(rest)) {
      Object.keys(rest).forEach((element: any) => {
        valueFilter.push({
          id: TypeFilter[element as keyof typeof TypeFilter],
          value: rest[element],
          operation: "AND",
        });
      });
    }
    setFilter(valueFilter);
  };

  const emptyNotify = () => {
    return {
      title: "",
      message: "",
      startDate: "",
      roleList: [].join(", "),
    };
  };

  const handlePlusBtn = () => {
    setIsEdit(false);
    setToEdit(emptyNotify());
    setShowAddEditModal(true);
  };

  const onEditRow = (id: string | number) => {
    setIsEdit(true);
    const selected = niceData.filter((notify) => notify.uniqueId === id)[0];
    if (selected) {
      setToEdit(selected);
      setShowAddEditModal(true);
    }
  };

  const deleteHandler = (id: string) => {
    setToDel(id);
    setIsDel(true);
    setShowConfirmModal(true);
  };

  const handleCancelOp = () => {
    setShowConfirmModal(false);
    setIsDel(false);
    setIsReplay(false);
  };

  const handleConfirmOp = () => {
    if (isDel) {
      deleteNotify(toDel);
      setShowConfirmModal(false);
      setShowResponseDeleteModal(true);
    }
    if (isReplay) {
      replayNotify(toReplay);
      setShowConfirmModal(false);
      setShowResponseReplayModal(true);
    }
  };

  const handleCancelAddEdit = () => {
    setShowAddEditModal(false);
  };

  const handleCloseReponseModal = () => {
    setShowResponseDeleteModal(false);
    setShowResponseReplayModal(false);
    getNotificationsPaginationTableData(0, pageSize, filter);
    setIsDel(false);
    setIsReplay(false);
  };

  const onReplay = (id: string) => {
    let selected = notifications.messages.filter((el) => el.uniqueId === id)[0];
    if (selected) {
      let data: INotifyGet = {
        id: selected.uniqueId,
        title: selected.title,
        message: selected.message,
        startDate: new Date().getTime(),
        roles: selected.roleList.split(", "),
      };
      setToReplay(data);
      setIsReplay(true);
      setShowConfirmModal(true);
    }
  };

  return (
    <>
      <ConfirmModal
        show={showConfirmModal}
        onCancel={handleCancelOp}
        onConfirm={handleConfirmOp}
      />

      <ResponseModal
        show={showResponseDeleteModal}
        onClose={handleCloseReponseModal}
        state={responseDelete}
        showSuccessForwardMessage={true}
      />

      <ResponseModal
        show={showResponseReplayModal}
        onClose={handleCloseReponseModal}
        state={responseReplay}
        showSuccessForwardMessage={true}
      />

      <AddEditNotifyModal
        show={showAddEditModal}
        setShow={setShowAddEditModal}
        responseUpdateState={responseAddEditState}
        isEdit={isEdit}
        toEdit={toEdit}
        onClose={handleCancelAddEdit}
        sendUpdate={updateNotify}
        sendNew={sendNotify}
        onCloseResponse={() =>
          getNotificationsPaginationTableData(0, 10, filter)
        }
        allRoles={allRoles}
      />

      <div className={"actions-top"}>
        <OutlinedButton onClick={() => changeLocation(ROUTES.CONSOLE_ADMIN)}>
          <FormattedMessage {...messages.CTABack} />
        </OutlinedButton>
      </div>

      <div className={classes.notifyPanel}>
        <Panel
          title={<FormattedMessage {...messages.panelTitle} />}
          icon={<FaPlus onClick={handlePlusBtn} className={classes.button} />}
        >
          {}
          <FilterTable
            messages={filterMessages}
            formProps={form}
            onSubmitProps={(val: any) => onSubmit(val)}
            isAccordion={true}
          />

          {niceData && niceData.length > 0 ? (
            <Table
              filterProps={filter}
              dataSource={niceData}
              rowsChangeable={true}
              initialState={{}}
              showCTAButton={true}
              areRowEditable
              onEditRow={(uniqueId: string) => onEditRow(uniqueId)}
              areRowDeletable
              onDeleteRow={(uniqueId: string) => deleteHandler(uniqueId)}
              areRowReplayable
              onReplay={(uniqueId: string) => onReplay(uniqueId)}
              tableName={"notifications_table"}
              serverSidePagination
              serverSideSorting
              fetchData={getNotificationsPaginationTableData}
              pageCount={pageTotalNumber}
              totalElements={totalElements}
              pageIndexProp={pageIndex}
              pageSizeProp={pageSize}
              sortByProp={sortBy}
            />
          ) : (
            <div className={classes.emptyTableMessage}>
              <FormattedMessage {...messages.emptyTable} />
            </div>
          )}
          {}
        </Panel>
      </div>

      <div className={"actions-bottom"}>
        <OutlinedButton onClick={() => changeLocation(ROUTES.CONSOLE_ADMIN)}>
          <FormattedMessage {...messages.CTABack} />
        </OutlinedButton>
      </div>
    </>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    notifications: notifySelector,
    responseDelete: responseDeleteSelector,
    responseAddEditState: responseAddEditSelector,
    responseReplay: responseReplaySelector,
    allRoles: allRolesSelector,
  });

const mapDispatchToProps: any = {
  changeLocation: (url: any) => push(url),
  getNotifications: (body: INotifyCall, sortBy: SortingRule<{}>[]) =>
    getNotificationsAction(body, sortBy),
  getAllRoles: () => getAllRolesAction(),
  deleteNotify: (id: string) => deleteNotifyAction(id),
  sendNotify: (data: INotify) => sendNotifyAction(data),
  updateNotify: (data: INotify) => updateNotifyAction(data),
  replayNotify: (data: INotify) => replayNotifyAction(data),
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(NotifyManagement);
